import React, { useEffect, Suspense, lazy } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
// Lazy load components below the fold for faster initial page load
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const SocialProofSection = lazy(() => import('./components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const DifferentiationSection = lazy(() => import('./components/DifferentiationSection').then(m => ({
  default: m.DifferentiationSection
})));
const NfcTapAnimation = lazy(() => import('./components/NfcTapAnimation').then(m => ({
  default: m.NfcTapAnimation
})));
const ComparisonSection = lazy(() => import('./components/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const ShopSection = lazy(() => import('./components/ShopSection').then(m => ({
  default: m.ShopSection
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const VideoDemoSection = lazy(() => import('./components/VideoDemoSection').then(m => ({
  default: m.VideoDemoSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCtaSection = lazy(() => import('./components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
const BundleDealPopup = lazy(() => import('./components/BundleDealPopup').then(m => ({
  default: m.BundleDealPopup
})));
export function App() {
  useEffect(() => {
    document.title = 'QTap WC Smart T-Shirt';
    // Force scroll to top on load to prevent browser from jumping to hash links or restoring scroll position
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-brand-darkest font-body text-white overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={<div className="h-32 flex items-center justify-center" data-id="element-5">
              <div className="w-8 h-8 border-2 border-brand-cyan border-t-transparent rounded-full animate-spin" data-id="element-6"></div>
            </div>} data-id="element-4">
          <ProblemSection data-id="element-7" />
          <SolutionSection data-id="element-8" />
          <NfcTapAnimation data-id="element-9" />
          <BenefitsSection data-id="element-10" />
          <DifferentiationSection data-id="element-11" />
          <ComparisonSection data-id="element-12" />
          <ShopSection data-id="element-13" />
          <UrgencySection data-id="element-14" />
          <VideoDemoSection data-id="element-15" />
          <SocialProofSection data-id="element-16" />
          <FAQSection data-id="element-17" />
          <FinalCtaSection data-id="element-18" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-19">
        <Footer data-id="element-20" />
        <SocialProofPopup data-id="element-21" />
        <BundleDealPopup data-id="element-22" />
      </Suspense>
    </div>;
}